import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TrackingService {
  
  constructor(private http: HttpClient) { }

  httpOptions={
    headers:new HttpHeaders({
      'content-type':'application'
    })
  }
  getTracking(id){
    return this.http.get('https://bmcargos.com/tracking/api/index.php/get_track_142?track_number='+id);
 }
 getPodImageBase64String(filePath){
  return this.http.post('https://bmcargos.com/tracking/api/index.php/convertImageToBase64',JSON.stringify(filePath))
 }
 
}
